import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=06987fce&"
import script from "./Youtube.vue?vue&type=script&lang=ts&"
export * from "./Youtube.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports